import React from 'react';
import { Bubble } from 'tea-component';
import { useIntl } from 'umi';
import DatalabGrid from '@/pages/datalab/components/DatalabGrid';
import LabelText from '@/pages/datalab/components/LabelText';
import { UserFilterControlFilterText } from '@/pages/datalab/components/BubbleListContent/AllBubbleList';
import MetricChangePercent from '@/pages/datalab/components/MetricUpAndDownComponents/MetricChangePercent';
import MetricChangeSmallBox from '@/pages/datalab/components/MetricUpAndDownComponents/MetricChangeSmallBox';
import MetricVsBubble from '@/pages/datalab/components/MetricUpAndDownComponents/MetricVsBubble';
import { LANGUAGE_EN } from '@home/_config/config';
import './index.scss';

interface IUserFilterBigNumbersProps {
  data?: Array<{
    controlNameEn?: string;
    controlNameCn?: string;
    summaryEn?: string;
    summaryCn?: string;
    content?: React.ReactNode;
    timeComparisons?: Array<{
      name_en: string;
      name_cn: string;
      percent: number;
      date: string;
      value: string | number | React.ReactNode;
    }>;
  }>;
  staticTime?: string;
}

const UserFilterBigNumbers: React.FC<IUserFilterBigNumbersProps> = ({
  data,
  staticTime,
}) => {
  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;

  return (
    <DatalabGrid
      className="dbl-big-number-user-filter"
      colCount={2}
      gap={20}
      rowGap={10}
      columnWidthMode={['1fr', 'max-content']}
    >
      {data?.map((item, index) => {
        const {
          controlNameEn,
          controlNameCn,
          summaryEn,
          summaryCn,
          content,
          timeComparisons,
        } = item;
        const controlName = isEn ? controlNameEn : controlNameCn;
        const summary = isEn ? summaryEn : summaryCn;
        const compareData = timeComparisons?.map((compareItem) => ({
          leftTitle: isEn ? compareItem.name_en : compareItem.name_cn,
          rightTitle: <MetricChangePercent value={compareItem.percent} />,
          thisTime: staticTime,
          lastTime: compareItem.date,
          thisValue: content,
          lastValue: compareItem.value,
        })) ?? [];

        return (
          <React.Fragment key={index}>
            <LabelText preset="838697-14-400" ellipsis>
              <Bubble
                content={
                  <UserFilterControlFilterText
                    title={controlName}
                    text={summary}
                  />
                }
                placement="top-start"
              >
                {controlName}
              </Bubble>
            </LabelText>

            <MetricVsBubble data={compareData} contentTitle={controlName}>
              <MetricChangeSmallBox
                title={content}
                change={timeComparisons?.[0]?.percent}
                showChange={!!timeComparisons?.length}
              />
            </MetricVsBubble>
          </React.Fragment>
        );
      })}
    </DatalabGrid>
  );
};

export default UserFilterBigNumbers;